import type { OneToThirty, ScaleSelectorProps } from "@qendo/profile/journal";
import { ScaleType } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RangeInput } from "~/components/form/RangeInput";

export type OneToThirtySelectorProps = ScaleSelectorProps<ScaleType.thirty>;

const clamp = (input: number | null | undefined): OneToThirty | 0 => {
    return Math.max(0, Math.min(30, Math.abs(input ?? 0))) as OneToThirty | 0;
};
export const OneToThirtySelector = ({ value, onUpdateScale, zIndex, ...rangeProps }: OneToThirtySelectorProps) => {
    const scale = clamp(value?.value);

    const changeScale = (val: number) => {
        scale !== val &&
            onUpdateScale({
                type: ScaleType.thirty,
                value: val === 0 ? null : (clamp(val) as OneToThirty),
            });
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RangeInput {...rangeProps} min={1} max={30} step={1} value={scale} onValueChange={changeScale} />
        </FieldGroup>
    );
};
